import React from 'react';
import { Link } from 'react-router-dom';
import { NAV, SITE } from '../../config/siteConfig';
import { Icon } from '../ui';
import './layout.css';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="ftr">
      <div className="wrap">
        <div className="ftr-grid">
          <div className="ftr-brand">
            <img src="/static/images/logo.svg" alt="Trinity Laser Profile" className="ftr-logo" />
            <p className="ftr-tag">{SITE.tagline}</p>
            <ul className="ftr-contact">
              <li><Icon name="mapPin" size={15} /><span>{SITE.contact.addressLine1}<br />{SITE.contact.addressLine2}</span></li>
              <li><Icon name="phone" size={15} /><a href={SITE.contact.phoneHref}>{SITE.contact.phone}</a></li>
              <li><Icon name="external" size={15} /><a href={SITE.contact.websiteHref} target="_blank" rel="noreferrer">{SITE.contact.website}</a></li>
              {SITE.contact.email && <li><Icon name="mail" size={15} /><a href={'mailto:' + SITE.contact.email}>{SITE.contact.email}</a></li>}
            </ul>
          </div>

          {NAV.footer.map(col => (
            <div key={col.title} className="ftr-col">
              <div className="ftr-title">{col.title}</div>
              <ul>
                {col.links.map(l => (
                  <li key={l.to}>
                    <Link to={l.to}>{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="ftr-bottom">
          <div className="ftr-copy mono">
            © {year} {SITE.name} · {SITE.legal.abn}
          </div>
          <div className="ftr-meta">
            <Link to="/terms">Terms</Link>
            <Link to="/privacy">Privacy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
